export class ImageLoadPromise {

    constructor(elements:JQuery<HTMLElement>) {
        return Promise.all((<JQuery<HTMLImageElement>>elements).map((idx,img)=>{
            if (img.complete) return Promise.resolve();
            return new Promise(resolve => {
                img.addEventListener('load', resolve);
                img.addEventListener('error', resolve);
            });
        }));
    }

}

export {};